import React, { FunctionComponent, useEffect } from "react"
import HeartIcon from "../assets/heart"
import { loadExternalScripts } from "../utils/loadExternalScript"

interface TwitterWallProps {
  title: string
  bgColor?: string
}

const TwitterWall: FunctionComponent<TwitterWallProps> = ({
  title,
  bgColor = "palePink",
}) => {
  useEffect(() => {
    loadExternalScripts("https://embed.shoutout.so/embed.js")
  }, [])
const TwitterCss = {
   background: `var(--theme-${bgColor})`,
   padding:'120px 0px 60px',
};
  return (
    <div
      className="twitter-comments"
      style={TwitterCss}
    >
      <div className="h2Text">{title}</div>
      <div className="heats-container">
        <HeartIcon color="var(--theme-purple)" />
        <HeartIcon />
        <HeartIcon color="var(--theme-red)" />
        <HeartIcon color="var(--theme-lightBlue)" />
        <HeartIcon color="var(--theme-green)" />
        <HeartIcon color="var(--theme-orange)" />
      </div>

      <div className="shoutout-embed" data-wall="thursday"></div>
    </div>
  )
}

export default TwitterWall
